"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es6.symbol.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetUpdateAddonsAction = exports.updateAddOnsFailure = exports.updateAddOnsSuccess = exports.updateAddOnsRequest = exports.resumePurchaseReset = exports.resumePurchaseFlowFailure = exports.resumePurchaseFlowSuccess = exports.resumePurchaseFlowRequest = exports.resetUserSelectHomeAction = exports.userSaveFuneralHomeFailure = exports.userSaveFuneralHomeSuccess = exports.userSaveFuneralHomeRequest = exports.userUpdateLastScreenFailure = exports.userUpdateLastScreenSuccess = exports.userUpdateLastScreenRequest = exports.resetSubmitOrderAction = exports.submitOrderFailure = exports.submitOrderSuccess = exports.submitOrderRequest = exports.userStartSaleFailure = exports.userStartSaleSuccess = exports.userStartSaleRequest = exports.resetUserPreneedDetailsAction = exports.resetUserBirthdayUpdatedAction = exports.resetPlanPackageUpdatedAction = exports.resetSelectedPlanAction = exports.resetSelectedPackageAction = exports.resetWebleadUpdatedAction = exports.updateWebleadDataFailure = exports.updateWebleadDataSuccess = exports.updateWebleadDataRequest = exports.updateUserPreneedDetailsFailure = exports.updateUserPreneedDetailsSuccess = exports.updateUserPreneedDetailsRequest = exports.updateUserBirthdayFailure = exports.updateUserBirthdaySuccess = exports.updateUserBirthdayRequest = exports.updateUserPackageFailure = exports.updateUserPackageSuccess = exports.updateUserPackageRequest = exports.savePlanToUserFailure = exports.savePlanToUserSuccess = exports.savePlanToUserRequest = exports.savePackageToUserFailure = exports.savePackageToUserSuccess = exports.savePackageToUserRequest = exports.resetCreatePreneedUserAction = exports.createPreneedUserFailure = exports.createPreneedUserSuccess = exports.createPreneedUserRequest = exports.saveUserPhoneFailure = exports.saveUserPhoneSuccess = exports.saveUserPhoneRequest = exports.editProfileUserFailure = exports.editProfileUserSuccess = exports.editProfileUserRequest = exports.resetErrorAction = exports.resetMetaAction = exports.V2LoginFailure = exports.V2LoginSuccess = exports.V2LoginRequest = exports.confirmUserFailure = exports.confirmUserSuccess = exports.confirmUserRequest = exports.shellLoginFailure = exports.shellLoginSuccess = exports.shellLoginRequest = exports.verifyPinFailure = exports.verifyPinSuccess = exports.verifyPinRequest = exports.sendPinAndCallFailure = exports.sendPinAndCallSuccess = exports.sendPinAndCallRequest = exports.sendPinFailure = exports.sendPinSuccess = exports.sendPinRequest = exports.editUserByIdError = exports.editUserByIdSuccess = exports.editUserByIdRequest = exports.loginByIdError = exports.loginByIdSuccess = exports.loginByIdRequest = exports.dashLoginFailure = exports.dashLoginSuccess = exports.dashLoginRequest = void 0;

var types = _interopRequireWildcard(require("./constants"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Dash Login
var dashLoginRequest = function dashLoginRequest() {
  return {
    type: types.DASH_LOGIN_REQUEST
  };
};

exports.dashLoginRequest = dashLoginRequest;

var dashLoginSuccess = function dashLoginSuccess(_ref) {
  var data = _ref.data;
  return {
    type: types.DASH_LOGIN_SUCCESS,
    payload: data.data,
    receivedAt: Date.now()
  };
};

exports.dashLoginSuccess = dashLoginSuccess;

var dashLoginFailure = function dashLoginFailure(error) {
  return {
    type: types.DASH_LOGIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Invited share page login


exports.dashLoginFailure = dashLoginFailure;

var loginByIdRequest = function loginByIdRequest() {
  return {
    type: types.ID_LOGIN_REQUEST
  };
};

exports.loginByIdRequest = loginByIdRequest;

var loginByIdSuccess = function loginByIdSuccess(data) {
  return {
    type: types.ID_LOGIN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.loginByIdSuccess = loginByIdSuccess;

var loginByIdError = function loginByIdError(error) {
  return {
    type: types.ID_LOGIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.loginByIdError = loginByIdError;

var editUserByIdRequest = function editUserByIdRequest() {
  return {
    type: types.EDIT_USER_BY_ID_REQUEST
  };
};

exports.editUserByIdRequest = editUserByIdRequest;

var editUserByIdSuccess = function editUserByIdSuccess(data) {
  return {
    type: types.EDIT_USER_BY_ID_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editUserByIdSuccess = editUserByIdSuccess;

var editUserByIdError = function editUserByIdError(error) {
  return {
    type: types.EDIT_USER_BY_ID_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // V2 Login


exports.editUserByIdError = editUserByIdError;

var sendPinRequest = function sendPinRequest() {
  return {
    type: types.SEND_PIN_REQUEST
  };
};

exports.sendPinRequest = sendPinRequest;

var sendPinSuccess = function sendPinSuccess(data) {
  return {
    type: types.SEND_PIN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.sendPinSuccess = sendPinSuccess;

var sendPinFailure = function sendPinFailure(error) {
  return {
    type: types.SEND_PIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.sendPinFailure = sendPinFailure;

var sendPinAndCallRequest = function sendPinAndCallRequest() {
  return {
    type: types.SEND_PIN_AND_CALL_REQUEST
  };
};

exports.sendPinAndCallRequest = sendPinAndCallRequest;

var sendPinAndCallSuccess = function sendPinAndCallSuccess(data) {
  return {
    type: types.SEND_PIN_AND_CALL_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.sendPinAndCallSuccess = sendPinAndCallSuccess;

var sendPinAndCallFailure = function sendPinAndCallFailure(error) {
  return {
    type: types.SEND_PIN_AND_CALL_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.sendPinAndCallFailure = sendPinAndCallFailure;

var verifyPinRequest = function verifyPinRequest() {
  return {
    type: types.VERIFY_PIN_REQUEST
  };
};

exports.verifyPinRequest = verifyPinRequest;

var verifyPinSuccess = function verifyPinSuccess(data) {
  return {
    type: types.VERIFY_PIN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.verifyPinSuccess = verifyPinSuccess;

var verifyPinFailure = function verifyPinFailure(error) {
  return {
    type: types.VERIFY_PIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.verifyPinFailure = verifyPinFailure;

var shellLoginRequest = function shellLoginRequest() {
  return {
    type: types.V2_SHELL_LOGIN_REQUEST
  };
};

exports.shellLoginRequest = shellLoginRequest;

var shellLoginSuccess = function shellLoginSuccess(data) {
  return {
    type: types.V2_SHELL_LOGIN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.shellLoginSuccess = shellLoginSuccess;

var shellLoginFailure = function shellLoginFailure(error) {
  return {
    type: types.V2_SHELL_LOGIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.shellLoginFailure = shellLoginFailure;

var confirmUserRequest = function confirmUserRequest() {
  return {
    type: types.V2_CONFIRM_USER_REQUEST
  };
};

exports.confirmUserRequest = confirmUserRequest;

var confirmUserSuccess = function confirmUserSuccess(data) {
  return {
    type: types.V2_CONFIRM_USER_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.confirmUserSuccess = confirmUserSuccess;

var confirmUserFailure = function confirmUserFailure(error) {
  return {
    type: types.V2_CONFIRM_USER_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.confirmUserFailure = confirmUserFailure;

var V2LoginRequest = function V2LoginRequest() {
  return {
    type: types.V2_LOGIN_REQUEST
  };
};

exports.V2LoginRequest = V2LoginRequest;

var V2LoginSuccess = function V2LoginSuccess(data) {
  return {
    type: types.V2_LOGIN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.V2LoginSuccess = V2LoginSuccess;

var V2LoginFailure = function V2LoginFailure(error) {
  return {
    type: types.V2_LOGIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.V2LoginFailure = V2LoginFailure;

var resetMetaAction = function resetMetaAction() {
  return {
    type: types.RESET_META
  };
};

exports.resetMetaAction = resetMetaAction;

var resetErrorAction = function resetErrorAction() {
  return {
    type: types.RESET_ERROR
  };
}; // Profile Page Edit User


exports.resetErrorAction = resetErrorAction;

var editProfileUserRequest = function editProfileUserRequest() {
  return {
    type: types.V2_EDIT_USER_PROFILE_REQUEST
  };
};

exports.editProfileUserRequest = editProfileUserRequest;

var editProfileUserSuccess = function editProfileUserSuccess(data) {
  return {
    type: types.V2_EDIT_USER_PROFILE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editProfileUserSuccess = editProfileUserSuccess;

var editProfileUserFailure = function editProfileUserFailure(error) {
  return {
    type: types.V2_EDIT_USER_PROFILE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Save a phone number to user


exports.editProfileUserFailure = editProfileUserFailure;

var saveUserPhoneRequest = function saveUserPhoneRequest() {
  return {
    type: types.SAVE_USER_PHONE_REQUEST
  };
};

exports.saveUserPhoneRequest = saveUserPhoneRequest;

var saveUserPhoneSuccess = function saveUserPhoneSuccess(data) {
  return {
    type: types.SAVE_USER_PHONE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.saveUserPhoneSuccess = saveUserPhoneSuccess;

var saveUserPhoneFailure = function saveUserPhoneFailure(error) {
  return {
    type: types.SAVE_USER_PHONE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};
/** Purchase Flow */
// create a new preneed user


exports.saveUserPhoneFailure = saveUserPhoneFailure;

var createPreneedUserRequest = function createPreneedUserRequest() {
  return {
    type: types.CREATE_NEW_PRENEED_USER_REQUEST
  };
};

exports.createPreneedUserRequest = createPreneedUserRequest;

var createPreneedUserSuccess = function createPreneedUserSuccess(data) {
  return {
    type: types.CREATE_NEW_PRENEED_USER_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.createPreneedUserSuccess = createPreneedUserSuccess;

var createPreneedUserFailure = function createPreneedUserFailure(error) {
  return {
    type: types.CREATE_NEW_PRENEED_USER_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.createPreneedUserFailure = createPreneedUserFailure;

var resetCreatePreneedUserAction = function resetCreatePreneedUserAction() {
  return {
    type: types.RESET_CREATE_NEW_PRENEED_USER
  };
}; // Save selected package


exports.resetCreatePreneedUserAction = resetCreatePreneedUserAction;

var savePackageToUserRequest = function savePackageToUserRequest() {
  return {
    type: types.SAVE_PACKAGE_TO_USER_REQUEST
  };
};

exports.savePackageToUserRequest = savePackageToUserRequest;

var savePackageToUserSuccess = function savePackageToUserSuccess(data) {
  return {
    type: types.SAVE_PACKAGE_TO_USER_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.savePackageToUserSuccess = savePackageToUserSuccess;

var savePackageToUserFailure = function savePackageToUserFailure(error) {
  return {
    type: types.SAVE_PACKAGE_TO_USER_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Save selected plan


exports.savePackageToUserFailure = savePackageToUserFailure;

var savePlanToUserRequest = function savePlanToUserRequest() {
  return {
    type: types.SAVE_PLAN_TO_USER_REQUEST
  };
};

exports.savePlanToUserRequest = savePlanToUserRequest;

var savePlanToUserSuccess = function savePlanToUserSuccess(data) {
  return {
    type: types.SAVE_PLAN_TO_USER_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.savePlanToUserSuccess = savePlanToUserSuccess;

var savePlanToUserFailure = function savePlanToUserFailure(error) {
  return {
    type: types.SAVE_PLAN_TO_USER_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; //update package and terms on user


exports.savePlanToUserFailure = savePlanToUserFailure;

var updateUserPackageRequest = function updateUserPackageRequest() {
  return {
    type: types.UPDATE_USER_PACKAGE_REQUEST
  };
};

exports.updateUserPackageRequest = updateUserPackageRequest;

var updateUserPackageSuccess = function updateUserPackageSuccess(data) {
  return {
    type: types.UPDATE_USER_PACKAGE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.updateUserPackageSuccess = updateUserPackageSuccess;

var updateUserPackageFailure = function updateUserPackageFailure(error) {
  return {
    type: types.UPDATE_WEBLEAD_FAILURE,
    error: error,
    receviedAt: Date.now()
  };
}; //update user birthday


exports.updateUserPackageFailure = updateUserPackageFailure;

var updateUserBirthdayRequest = function updateUserBirthdayRequest() {
  return {
    type: types.UPDATE_USER_BIRTHDAY_REQUEST
  };
};

exports.updateUserBirthdayRequest = updateUserBirthdayRequest;

var updateUserBirthdaySuccess = function updateUserBirthdaySuccess(data) {
  return {
    type: types.UPDATE_USER_BIRTHDAY_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.updateUserBirthdaySuccess = updateUserBirthdaySuccess;

var updateUserBirthdayFailure = function updateUserBirthdayFailure(error) {
  return {
    type: types.UPDATE_USER_BIRTHDAY_FAILURE,
    error: error,
    receviedAt: Date.now()
  };
}; // update user preneed details


exports.updateUserBirthdayFailure = updateUserBirthdayFailure;

var updateUserPreneedDetailsRequest = function updateUserPreneedDetailsRequest() {
  return {
    type: types.UPDATE_USER_PRENEED_DETAILS_REQUEST
  };
};

exports.updateUserPreneedDetailsRequest = updateUserPreneedDetailsRequest;

var updateUserPreneedDetailsSuccess = function updateUserPreneedDetailsSuccess(data) {
  return {
    type: types.UPDATE_USER_PRENEED_DETAILS_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.updateUserPreneedDetailsSuccess = updateUserPreneedDetailsSuccess;

var updateUserPreneedDetailsFailure = function updateUserPreneedDetailsFailure(error) {
  return {
    type: types.UPDATE_USER_PRENEED_DETAILS_FAILURE,
    error: error,
    receviedAt: Date.now()
  };
}; // Update eFuneral data on user - okay to delete? - Marc 4.13.2021


exports.updateUserPreneedDetailsFailure = updateUserPreneedDetailsFailure;

var updateWebleadDataRequest = function updateWebleadDataRequest() {
  return {
    type: types.UPDATE_WEBLEAD_DATA_REQUEST
  };
};

exports.updateWebleadDataRequest = updateWebleadDataRequest;

var updateWebleadDataSuccess = function updateWebleadDataSuccess(data) {
  return {
    type: types.UPDATE_WEBLEAD_DATA_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.updateWebleadDataSuccess = updateWebleadDataSuccess;

var updateWebleadDataFailure = function updateWebleadDataFailure(error) {
  return {
    type: types.UPDATE_WEBLEAD_DATA_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.updateWebleadDataFailure = updateWebleadDataFailure;

var resetWebleadUpdatedAction = function resetWebleadUpdatedAction() {
  return {
    type: types.RESET_WEBLEAD_UPDATED
  };
};

exports.resetWebleadUpdatedAction = resetWebleadUpdatedAction;

var resetSelectedPackageAction = function resetSelectedPackageAction() {
  return {
    type: types.RESET_SELECTED_PACKAGE
  };
};

exports.resetSelectedPackageAction = resetSelectedPackageAction;

var resetSelectedPlanAction = function resetSelectedPlanAction() {
  return {
    type: types.RESET_SELECTED_PLAN
  };
};

exports.resetSelectedPlanAction = resetSelectedPlanAction;

var resetPlanPackageUpdatedAction = function resetPlanPackageUpdatedAction() {
  return {
    type: types.RESET_PLAN_PACKAGE_UPDATED
  };
};

exports.resetPlanPackageUpdatedAction = resetPlanPackageUpdatedAction;

var resetUserBirthdayUpdatedAction = function resetUserBirthdayUpdatedAction() {
  return {
    type: types.RESET_USER_BIRTHDAY_UPDATED
  };
};

exports.resetUserBirthdayUpdatedAction = resetUserBirthdayUpdatedAction;

var resetUserPreneedDetailsAction = function resetUserPreneedDetailsAction() {
  return {
    type: types.RESET_USER_PRENEED_DETAILS_UPDATED
  };
}; // Auth user start sale


exports.resetUserPreneedDetailsAction = resetUserPreneedDetailsAction;

var userStartSaleRequest = function userStartSaleRequest() {
  return {
    type: types.USER_START_SALE_REQUEST
  };
};

exports.userStartSaleRequest = userStartSaleRequest;

var userStartSaleSuccess = function userStartSaleSuccess(_ref2) {
  var data = _ref2.data;
  return {
    type: types.USER_START_SALE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.userStartSaleSuccess = userStartSaleSuccess;

var userStartSaleFailure = function userStartSaleFailure(error) {
  return {
    type: types.USER_START_SALE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Submit order


exports.userStartSaleFailure = userStartSaleFailure;

var submitOrderRequest = function submitOrderRequest() {
  return {
    type: types.SUBMIT_ORDER_REQUEST
  };
};

exports.submitOrderRequest = submitOrderRequest;

var submitOrderSuccess = function submitOrderSuccess(data) {
  return {
    type: types.SUBMIT_ORDER_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.submitOrderSuccess = submitOrderSuccess;

var submitOrderFailure = function submitOrderFailure(error) {
  return {
    type: types.SUBMIT_ORDER_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.submitOrderFailure = submitOrderFailure;

var resetSubmitOrderAction = function resetSubmitOrderAction() {
  return {
    type: types.RESET_SUBMIT_ORDER
  };
}; // Last Screen visited in purchase flow


exports.resetSubmitOrderAction = resetSubmitOrderAction;

var userUpdateLastScreenRequest = function userUpdateLastScreenRequest() {
  return {
    type: types.SAVE_LAST_SCREEN_REQUEST
  };
};

exports.userUpdateLastScreenRequest = userUpdateLastScreenRequest;

var userUpdateLastScreenSuccess = function userUpdateLastScreenSuccess(_ref3) {
  var data = _ref3.data;
  return {
    type: types.SAVE_LAST_SCREEN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.userUpdateLastScreenSuccess = userUpdateLastScreenSuccess;

var userUpdateLastScreenFailure = function userUpdateLastScreenFailure(error) {
  return {
    type: types.SAVE_LAST_SCREEN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Funeral Home saved to user.preneed


exports.userUpdateLastScreenFailure = userUpdateLastScreenFailure;

var userSaveFuneralHomeRequest = function userSaveFuneralHomeRequest() {
  return {
    type: types.SAVE_HOME_TO_USER_REQUEST
  };
};

exports.userSaveFuneralHomeRequest = userSaveFuneralHomeRequest;

var userSaveFuneralHomeSuccess = function userSaveFuneralHomeSuccess(_ref4) {
  var data = _ref4.data;
  return {
    type: types.SAVE_HOME_TO_USER_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.userSaveFuneralHomeSuccess = userSaveFuneralHomeSuccess;

var userSaveFuneralHomeFailure = function userSaveFuneralHomeFailure(error) {
  return {
    type: types.SAVE_HOME_TO_USER_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.userSaveFuneralHomeFailure = userSaveFuneralHomeFailure;

var resetUserSelectHomeAction = function resetUserSelectHomeAction() {
  return {
    type: types.SAVE_HOME_TO_USER_RESET
  };
}; // resume purchase


exports.resetUserSelectHomeAction = resetUserSelectHomeAction;

var resumePurchaseFlowRequest = function resumePurchaseFlowRequest() {
  return {
    type: types.RESUME_PURCHASE_LOGIN_REQUEST
  };
};

exports.resumePurchaseFlowRequest = resumePurchaseFlowRequest;

var resumePurchaseFlowSuccess = function resumePurchaseFlowSuccess(_ref5) {
  var data = _ref5.data;
  return {
    type: types.RESUME_PURCHASE_LOGIN_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.resumePurchaseFlowSuccess = resumePurchaseFlowSuccess;

var resumePurchaseFlowFailure = function resumePurchaseFlowFailure(error) {
  return {
    type: types.RESUME_PURCHASE_LOGIN_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.resumePurchaseFlowFailure = resumePurchaseFlowFailure;

var resumePurchaseReset = function resumePurchaseReset() {
  return {
    type: types.RESUME_PURCHASE_RESET
  };
}; // Update addons


exports.resumePurchaseReset = resumePurchaseReset;

var updateAddOnsRequest = function updateAddOnsRequest() {
  return {
    type: types.UPDATE_ADDONS_REQUEST
  };
};

exports.updateAddOnsRequest = updateAddOnsRequest;

var updateAddOnsSuccess = function updateAddOnsSuccess(_ref6) {
  var data = _ref6.data;
  return {
    type: types.UPDATE_ADDONS_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.updateAddOnsSuccess = updateAddOnsSuccess;

var updateAddOnsFailure = function updateAddOnsFailure(error) {
  return {
    type: types.UPDATE_ADDONS_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.updateAddOnsFailure = updateAddOnsFailure;

var resetUpdateAddonsAction = function resetUpdateAddonsAction() {
  return {
    type: types.UPDATE_ADDONS_RESET
  };
};

exports.resetUpdateAddonsAction = resetUpdateAddonsAction;